import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PaginationService } from '../../PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { messageService } from 'src/app/message.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-dms-notification-settings',
  templateUrl: './dms-notification-settings.component.html',
  styleUrls: ['./dms-notification-settings.component.scss']
})
export class DmsNotificationSettingsComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any = [];
  listOfDmsDocumentTypes: any = [];
  searchValue: any;
  dataTypeList: any = [];

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, public message: messageService,
    public paginationService: PaginationService, private readonly elem: ElementRef) { }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.grid = [];
    const data = {

      gridName: "DMS_NOTIFICATION_SETTINGS"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        const data1: any = {

          gridName: "DMS_NOTIFICATION_SETTINGS_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: []
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let arr = [];
            if (data1.columnsListarray[data1.columnsListarray.length - 1].includes("\r")) {
              arr = data1.columnsListarray[data1.columnsListarray.length - 1].split("\r");
              data1.columnsListarray[data1.columnsListarray.length - 1] = arr[0];
            }

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];

              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);

              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }


            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.fieldColumnarray[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                    this.columnLists.fieldColumnarray[m].dataType = dataType.fieldType;
                  }
                }
              }

              const checkboxColumns = this.dataTypeList
                .filter((d: any) => d.fieldType === 'CHECKBOX')
                .map((d: any) => d.columnName);

              for (const row of this.grid) {
                for (const colName of checkboxColumns) {
                  row[colName] = row[colName] === "Y";
                }
              } this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
              this.labelcall()
            });
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);

          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  focusEmpty() {
    console.log();
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetpage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.toString().trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toString().toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  counts: any;
  makeStickyColumns: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.grid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.NOTIFICATION_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.grid.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  ngOnInit() {

    this.appService.getDocumentTypeListFromOneQmsDocumentTypesVw().subscribe((data: any) => {
      this.listOfDmsDocumentTypes = data;
      this.selectBoxForDmsDocumentTypes();
    })

    this.getcallMethod();
  }

  refreshGridData() {
    this.getcallMethod();
  }

  dmsNotificationSettingsFieldData: any = {};
  operationFlag: any;
  popupTitle: any;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    //singleSelection: false,
    itemsShowLimit: 4,
  };

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  selectedDocumentTypeList: any = [];
  dmsDocumentTypeListDropdown: any = [];
  selectBoxForDmsDocumentTypes() {
    this.dmsDocumentTypeListDropdown = [];

    for (const docType of this.listOfDmsDocumentTypes) {
      this.dmsDocumentTypeListDropdown.push({
        valueExp: docType.documentTypeCode,
        displayExp: docType.documentTypeName
      });
    }
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  @ViewChild('documentTypeList') documentTypeList: MatSelect;
  isDocumentTypeListSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'documentTypeList') {
      if (this.isDocumentTypeListSelected) this.documentTypeList.options.forEach((item: MatOption) => item.select());
      else this.documentTypeList.options.forEach((item: MatOption) => item.deselect());
    }

  }


  documentTypeListSearchText: any;
  onDmsDocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        if (this.documentTypeListFieldValue != undefined) {
          this.documentTypeListFieldValue.style.color = '';
        }
      }
      setTimeout(() => { this.isDocumentTypeListSelected = this.dmsDocumentTypeListDropdown.length == this.selectedDocumentTypeList.length; })
    }
  }

  onDmsDocumentTypeRemoved(item: any) {
    if (this.documentTypeListFieldValue != undefined) {
      this.documentTypeListFieldValue.style.color = 'red';
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Documents Notification Settings";
    this.dmsNotificationSettingsFieldData = {};
    this.selectedDocumentTypeList = [];
    this.dmsNotificationSettingsFieldData.stopEmails = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editNotificationId: any;
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupTitle = "Update Documents Notification Settings";
    this.selectedDocumentTypeList = [];
    this.editNotificationId = editRowData.NOTIFICATION_ID;
    this.appService.getDmsNotificationSettingsVwDetailsByNotificationId(editRowData.NOTIFICATION_ID).subscribe((response: any) => {
      this.dmsNotificationSettingsFieldData = response;
      this.dmsNotificationSettingsFieldData.updateReason = '';
      this.appService.getDocumentTypeListFromOneQmsDocumentTypesVw().subscribe((data: any) => {
        this.listOfDmsDocumentTypes = data;

        this.selectBoxForDmsDocumentTypes();
        if (this.dmsNotificationSettingsFieldData.documentTypeList) {
          this.selectedDocumentTypeList = this.dmsNotificationSettingsFieldData.documentTypeList.split(",");
          setTimeout(() => { this.isDocumentTypeListSelected = this.dmsDocumentTypeListDropdown.length == this.selectedDocumentTypeList.length; })
        }

        this.isProcessing = false;

      })

      this.dmsNotificationSettingsFieldData.stopEmails = response.stopEmails == "Y";
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  documentTypeListFieldValue: any;
  updateVal: any;
  fieldValidation() {
    this.documentTypeListFieldValue = document.getElementById('documentTypeList-validation') as HTMLInputElement;
    this.updateVal = document.getElementById('update-validation') as HTMLInputElement;

    if (this.selectedDocumentTypeList.length == 0) {
      this.documentTypeListFieldValue.style.color = 'red';
    } else {
      this.documentTypeListFieldValue.style.color = '';
    }
    if (this.visibleEditButton) {
      if (this.dmsNotificationSettingsFieldData.updateReason) {
        this.updateVal.style.color = '';
      } else {
        this.updateVal.style.color = 'red';
      }
    }
  }

  onFieldFocusout() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;

    if (this.deleteReasonFieldValue != undefined) {
      if (this.dmsNotificationSettingsFieldData.deleteReason == "" || this.dmsNotificationSettingsFieldData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }

  addAndEditFunction(fieldData: any) {
    this.isProcessing = true;
    if (this.selectedDocumentTypeList.length == 0 || (this.visibleEditButton && !this.dmsNotificationSettingsFieldData.updateReason)) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else if (this.operationFlag == 'ADD') {

      fieldData.documentTypeList = '';
      if (this.selectedDocumentTypeList.length) {
        fieldData.documentTypeList = this.selectedDocumentTypeList.join(",");
      } else {
        fieldData.documentTypeList = null;
      }

      let addData = {
        ...fieldData,

        documentTypeList: fieldData.documentTypeList,
        stopEmails: fieldData.stopEmails ? "Y" : "N",
      }

      console.log(addData);
      this.appService.createDmsNotificationSettings(addData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

    } else {
      delete fieldData.createdOn;
      delete fieldData.updatedOn;

      fieldData.documentTypeList = '';
      if (this.selectedDocumentTypeList.length) {
        fieldData.documentTypeList = this.selectedDocumentTypeList.join(",");

      } else {
        fieldData.documentTypeList = null;
      }

      let editData = {
        ...fieldData,

        notificationId: this.editNotificationId,
        stopEmails: fieldData.stopEmails ? "Y" : "N",
      }

      console.log(editData);
      this.appService.updateDmsNotificationSettings(editData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteNotificationId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Documents Notification Settings";
    this.deleteNotificationId = deleteRowData.NOTIFICATION_ID;
    if (this.dmsNotificationSettingsFieldData.deleteReason != undefined) {
      this.dmsNotificationSettingsFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      let data = {

        notificationId: this.deleteNotificationId,
        deleteReason: this.dmsNotificationSettingsFieldData.deleteReason,
      }
      this.appService.deleteDmsNotificationSettings(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.NOTIFICATION_ID;
    this.auditTrail.gridName = 'DMS_NOTIFICATION_SETTINGS';
    this.auditTrail.report_And_Popup_Name = 'DMS Notification Settings Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'DMS Notification Settings Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
}
